export default __webpack_public_path__ + "static/prepare-door-153d59e44594c5c6530433bae964fdb7.png";